import { Download, Loader2 } from "lucide-react";

const FORM_LABELS = { w9: "W-9", w8ben: "W-8BEN", w8bene: "W-8BEN-E" };

const StatusPill = ({ status }) => {
  if (!status) {
    return (
      <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-white/5 text-neutral-500 border border-white/10">
        Desconocido
      </span>
    );
  }
  const ok = status === "sent";
  return (
    <span
      className={`text-[11px] font-semibold px-2 py-0.5 rounded-full ${
        ok ? "bg-emerald-500/10 text-emerald-400 border border-emerald-500/30" : "bg-brand-red/10 text-brand-red border border-brand-red/30"
      }`}
    >
      {ok ? "Enviado" : "Falló"}
    </span>
  );
};

export const AdminTaxFormsTable = ({ rows, downloadingCode, onDownload }) => (
  <div className="overflow-x-auto rounded-xl border border-white/10">
    <table className="w-full text-sm" data-testid="admin-taxforms-table">
      <thead>
        <tr className="border-b border-white/10 text-neutral-500 text-xs uppercase tracking-wide">
          <th className="text-left font-medium px-4 py-3">Código</th>
          <th className="text-left font-medium px-4 py-3">Formulario</th>
          <th className="text-left font-medium px-4 py-3">Nombre/Entidad</th>
          <th className="text-left font-medium px-4 py-3">Fecha</th>
          <th className="text-left font-medium px-4 py-3">IP</th>
          <th className="text-left font-medium px-4 py-3">Email admin</th>
          <th className="text-left font-medium px-4 py-3">PDF</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.code} data-testid={`admin-taxform-row-${r.code}`} className="border-b border-white/5 hover:bg-white/[0.02] transition-colors">
            <td className="px-4 py-3 font-mono text-xs text-brand-blue">{r.code}</td>
            <td className="px-4 py-3 font-semibold">{FORM_LABELS[r.form_type] || r.form_type}</td>
            <td className="px-4 py-3">{r.display_name}</td>
            <td className="px-4 py-3 text-neutral-400 whitespace-nowrap">
              {r.submitted_at ? new Date(r.submitted_at).toLocaleString("es-MX") : "—"}
            </td>
            <td className="px-4 py-3 text-neutral-400 font-mono text-xs">{r.ip_address}</td>
            <td className="px-4 py-3"><StatusPill status={r.admin_email_status} /></td>
            <td className="px-4 py-3">
              <button
                onClick={() => onDownload(r.code, r.form_type)}
                disabled={downloadingCode === r.code}
                data-testid={`admin-download-taxform-${r.code}`}
                className="flex items-center gap-1.5 text-xs font-semibold text-white bg-brand-red/90 hover:bg-brand-red px-3 py-1.5 rounded-full transition-colors disabled:opacity-50"
              >
                {downloadingCode === r.code ? <Loader2 className="w-3 h-3 animate-spin" /> : <Download className="w-3 h-3" />}
                PDF
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
